import Header from 'components/headerfull';
import { FooterMaximized } from 'components/footerfull';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import "../../styles/additional.css";
import { makeAlotOfEmptyStars, makeAlotOfStars } from 'components/company-slides';
import { StarHalf } from 'assets';
import { RoundBluePlain, RoundGreyPlain } from 'components/ui/Buttons/generic/GenericButton';
import { ContactUs } from 'pages/commentCamarche';
import { CarouselProvider, Slide, Slider } from 'pure-react-carousel';
import FreelanceCard, { FreelanceCardLoading, toTitleCase } from 'components/cards/FreelanceCard';
import useWindowSize from 'hooks/useWindowSize';
import { useEffect, useRef, useState } from 'react';

import right from '../../assets/arrow_right_alt-blue.svg';//src\assets\arrow_right_alt-blue.svg
import { BigLoadingButton, BigWhiteButton, SmallLoadingButton } from 'pages/profile';
import { text } from 'stream/consumers';
import { _getFreelances } from 'services/parcours/freelance.service';
import { get, post } from 'services/config';
import CirclePlay from '../../assets/circleplay.svg';
import CirclePause from '../../assets/circlepause.svg';
import { setDescription } from 'pages/accueil';
import InfoW from '../../assets/info_alert_w.svg';
import { atom, useRecoilState } from 'recoil';
import { freelanceBooking } from 'store';
import WYSIWYGEditor from 'components/ui/WYSIWYGEditor';


/**
 * Returns the last character of the given string.
 * @param str string
 * @returns {string}
 */
const lastCharOfString= (str: string) => {
    return str[str.length - 1];
};

/**
 * This will fix the description of the users that are so long they break the design and generally fix any text that is too long to fit in the container that contains it.
 * @param {string} input The string to process
 * @param {number} cuttof The maximum length
 * @param {string} breakingCharacter Character that should be used to break the string
 * @param {Array<string>} forbiddenCharacters A ist of characters that should be removed if they are at the end of the final processed string
 * @returns {string}
 */
export const shrotenTheVeryLongDesc= (input: string, cuttof: number= 1010, breakingCharacter: string = ".", forbiddenCharacters: Array<string>= [], keepBreaking: boolean= true) => {

    if (input.length<= cuttof) {
        return input;
    }

    const substr= input.slice(0, cuttof);
    const lastFullStopPosition= substr.lastIndexOf(breakingCharacter);

    let truncatedInput= keepBreaking ? substr.slice(0, lastFullStopPosition + 1) : substr.slice(0, lastFullStopPosition);

    forbiddenCharacters.forEach (char => {
        if (lastCharOfString(truncatedInput) === char){
            truncatedInput= truncatedInput.slice(0, truncatedInput.length - 1);
            truncatedInput= truncatedInput.trim();
        }
    });

    return truncatedInput;
};

export default function SingleFreelanceProfile(){
    
    const {index}= useParams();
    const indexNum= index=== undefined ? 0 : parseInt(index);

    const [userProfileData, setUserProfileData]= useState<any>({});

    const [notFound, setNotFound]= useState<boolean>(false);

    const location= useLocation();

    const [dataLoading, setDataLoading]= useState(true);

    const [modalShown, setModalShown]= useState<boolean>(false);
    const [requestSent, setRequestSent]= useState<boolean>(false);

    const requestIsSent= () => {
        setRequestSent(true);
    }

    useEffect(()=> {
        document.title = `${userProfileData.name || ""} - Wall of Share`;
        const desc = `Décrouvrez le profil de ${userProfileData.name || "ce freelance"}, un de nos workers.`;
        setDescription(desc);
    }, [userProfileData]);

    useEffect(() => {
        setDataLoading(true);
        setNotFound(false)
        get('api/freelances/' + indexNum, {}, { withCredentials: false })
        .then(response => {

            console.log("RESPONSE", response);

            if (!(response.status === 200)) {

                console.log(response.statusText);

                throw new Error('HTTP error! Status: ' + response.status);
                
            } else {
                const data: any = response.data;
                if (data.data) {
                    // console.log("Got something\n", data.data);
                    setUserProfileData(data.data);
                    setDataLoading(false);
                } else {
                    console.log('got nothing\n');
                }
            }
        }).catch(error => {
            console.error('got an error!\n', error);
            console.error('got an error!\n', error.status);
            
            if(error.status=== 404) {
                setNotFound(true);
                setDataLoading(false);
            }
        });
    }, [location.pathname]);

    const hideModal= () => {
        setModalShown(false);
    }

    return(
    <>
        <Header type="default"/>

        {
            modalShown &&
            <ModalForPrice
                data={{
                    name: userProfileData.name?.split(" ")[0],
                    salary: userProfileData.salary,
                    id: userProfileData.id,
                    favorite_domain: userProfileData.favorite_domain
                }}
                hideModal={hideModal}
                setRequestSent={requestIsSent}
            />
        }

        <ProfileBanner name={toTitleCase(userProfileData.name?.split(" ")[0])} notFound={notFound}/>

        {
            dataLoading ?
            <UserCardLoading />
            :
            <UserCard user={userProfileData} notFound={notFound} requestSent={requestSent} setModalShown={()=>setModalShown(true)}/>
        }

        {!notFound && <Domains user={userProfileData} />}
        <MoreFreelances />
        <ContactUs isFreelance={false} />
        <FooterMaximized />
    </>
    );
};

const ProfileBanner= ({name, notFound= false}: {name: any, notFound?: boolean}) => {
    return<>
        <div className="w-full lg:h-[260px] h-[100px] flex items-center justify-center bg-cover bg-center profile-banner">
            {
                notFound ?
                <h1 className="lg:text-[60px] lg:leading-[72px] text-[30px] leading-[36px] text-primary-blue font-semibold">Le profil de ce worker n'est pas disponible.</h1>
                :
                <h1 className="lg:text-[60px] lg:leading-[72px] text-[30px] leading-[36px] text-primary-blue font-semibold">Profil de {name}</h1>
            }
                
        </div>
    </>;
};

const FloatingPlayer= ({audioPath}:{audioPath: string|null}) => {

    const thePlayer= useRef<HTMLAudioElement>(null);
    const [isPLaying, setIsPlaying]= useState<boolean>(false);
    const location= useLocation();
    
    const playPause= (event: any) => {
        event.preventDefault();
        if ((audioPath=== null || audioPath=== '')) {
            return;
        }
        if (thePlayer.current?.paused) {
            thePlayer.current?.play();
            setIsPlaying(true);
        } else {
            thePlayer.current?.pause();
            setIsPlaying(false);
        }
    };

    useEffect(()=>{

        const stopAudio= () => {
            if(thePlayer.current) {
                setIsPlaying(false);
            }
        };

        if(thePlayer.current) {
            if(audioPath) {
                thePlayer.current.load();
            }
            thePlayer.current.addEventListener('ended', stopAudio);

            
            if (thePlayer.current.paused) {
                setIsPlaying(false);
            } else {
                setIsPlaying(true);
            }
        }
        
        return () => {
            if(thePlayer.current){
                thePlayer.current.removeEventListener('ended', stopAudio);
            }
        };
    }, [audioPath, location.pathname]);

    return <>
        <img src={isPLaying ? CirclePause : CirclePlay} alt="AUDIO" className={`w-full ${(audioPath==='' || audioPath=== null) ? 'cursor-not-allowed opacity-20' : 'cursor-pointer hover:opacity-50 duration-200'}`} title={(audioPath==='' || audioPath=== null) ? 'Pas de description audio' : 'Description audio disponible'} onClick={playPause}/>
        <audio controls ref={thePlayer} className="hidden">
            <source src={audioPath || '' } type="audio/ogg" />
            <source src={audioPath || '' } type="audio/mpeg" />
        </audio>
    </>;
};

const UserCard= ({user, notFound= false, requestSent= false, setModalShown}: {user: any, notFound?: boolean, requestSent?: boolean, setModalShown: ()=> void})=> {

    // const [isRequestSent, setRequestSent]= useState(requestSent);
    
    const [loggedIn, setLoggedIn]= useState<boolean>(false);
    const [customAudio, setCustomAudio]= useState<string|null>(user?.custom_audio?.file_url);
    const location= useLocation();

    const [requestPending, setRequestPending]= useState<boolean>(false);

    const [descOpen, setDescOpen]= useState<boolean>(false);

    const toggleDescOpen= () => {
        setDescOpen(s=>!s);
    };

    useEffect(()=> {
        setCustomAudio(user?.custom_audio?.file_url);
    }, [user]);
    
    const theDescRef= useRef<HTMLParagraphElement>(null);

    useEffect(()=>{

        const userData= localStorage.getItem("user");

        if (userData) {
            setLoggedIn(true);
        } else {
            setLoggedIn(false);
        }

        setCustomAudio(user?.custom_audio?.file_url);
        // console.log(user?.custom_audio?.file_url);

    }, [location]);

    const shrotenedDesc= shrotenTheVeryLongDesc(user.description);

    const sendRequest = () => {
        setRequestPending(true);
        post(
            'api/book-freelance',
            {
                clientID: localStorage.getItem('user_uid'),
                FreelanceID: user.id
            },
            { withCredentials: false }
        ).then(response => {
            if (!(response.status === 200)) {
                throw new Error('HTTP error! Status: ' + response.status);
            } else {
                setRequestPending(false);
                // setRequestSent(true);
            }
        }).catch(error => {
            console.error('request failed!\n', error);
            // setRequestPending(false);
        });
    };

    let salaryCname= "font-normal text-white ";
    salaryCname+= (parseInt(user.salary)> 9999) ? "text-[20px] leading-[26px]" : "text-[30px] leading-[36px]";

    const [booked, setBooked]= useRecoilState(freelanceBooking);
    const history= useNavigate();
    const bookForLater= (event: any) => {
        setBooked(user.id);
        history('/parcours-entreprise');
    };
    // useEffect(()=> {
    //     console.log(booked);
    // }, []);

    return<>
        {
            notFound ?
            <div className="max-w-[989px] py-[150px] mx-auto">
                <p className="text-center text-[#6F6F6F] font-medium text-xl font-dm-sans">L'utilisateur que vous cherchez a effacé son profil ou changé ses paramètres de compte. Veuillez en rechercer un autre.</p>
            </div>
            :
            <div className="lg:w-full w-[95vw] lg:max-w-[989px] max-w-[450px] lg:mt-[113px] mt-[80px] mx-auto rounded-[10px] overflow-hidden grid lg:grid-cols-[400px_auto] lg:grid-rows-[100%] grid-rows-[340px_auto] bg-[#f4f4f5]">
            <div className="w-full h-full overflow-hidden bg-cover bg-center relative" style={{backgroundImage: `url("${user?.image_url?.image_url_512 ?? user?.image_url?.image_url_128}")`}}>
                <img src={user?.image_url?.image_url_512 ?? user?.image_url?.image_url_128} alt="Profile" className="object-cover opacity-0" />
                {
                    !user.availability?.booked && 
                    <div className="absolute px-[15px] h-[56px] rounded-[5px] bg-white flex flex-row gap-[5px] items-center bottom-[26px] left-[20px]">
                        <div className="rounded-[50%] bg-[#0f0] w-[15px] h-[15px]"></div>
                        <div className="text-[22px] leading-[26.4px] font-normal text-[#6f6f6f]">Disponible</div>
                    </div>
                }
                <div className="absolute px-[20px] h-[56px] rounded-[5px] bg-primary-blue flex flex-row items-center bottom-[26px] right-[20px]">
                    <div className={salaryCname}>{Math.round(user.salary)}€</div>
                    <div className="text-[14px] leading-[16.8px] font-normal text-white">/{user.salaryPeriod || "mois"}</div>
                </div>
                <div className="absolute top-[20px] right-[20px] rounded-full bg-white w-[50px] h-[50px] p-[5px]">
                    {/* <FloatingPlayer audioPath={user.custom_audio.file_url}/> */}
                    <FloatingPlayer audioPath={customAudio}/>
                </div>
            </div>
            <div className="flex flex-col items-stretch gap-[25px] lg:px-[37px] lg:py-[33px] px-[30px] py-[30px]">
                <div className="flex flex-col gap-[12px]">
                    <div className="flex flex-row gap-[8px] items-center">
                        <h2 className="text-primary-blue text-[30px] font-medium leading-[36px]">{toTitleCase(user.name?.split(" ")[0])}</h2>
                        {
                            user.nbr_rating > 0 &&
                            <>
                            <div className="flex flex-row user-stars items-center">
                                {makeAlotOfStars(Math.floor(user.rating_avg))}
                                {((user.rating_avg - Math.floor(user.rating_avg))>= .5) && <img src={StarHalf} alt="star full" />}
                                {makeAlotOfEmptyStars(Math.round(5-user.rating_avg))}
                            </div>
                            <div className="text-[#6f6f6f] font-thin text-[14px]">({user.nbr_rating})</div>
                            </>
                        }
                    </div>
                    <div className="text-[20px] leading-[24px] font-normal text-primary-blue">{user.favorite_domain  ?? (user?.domains?.[0] === 'Non défini' ? null : user?.domains?.[0]) ?? user.function}</div>
                </div>
                <div className="flex flex-col gap-[15px]">
                    <div className="text-[20px] leading-[24px] font-normal text-primary-blue">Description</div>
                    {/* <p className="md:text-[16px] md:leading-[22.4px] text-[14px] leading-[16.8px] font-normal text-[#6f6f6f] lg:max-h-[65px] lg:max-h-[60px] overflow-hidden text-ellipsis">{user.description}</p> */}
                    {/* <p className="md:text-[16px] md:leading-[22.4px] text-[14px] leading-[16.8px] font-normal text-[#6f6f6f] overflow-hidden text-ellipsis">{user.description}</p> */}

                    <div className="hidden lg:block">
                        <div className={descOpen ? "md:text-[16px] md:leading-[22.4px] text-[14px] leading-[16.8px] font-normal text-[#6f6f6f] overflow-hidden text-ellipsis group" : "md:text-[16px] md:leading-[22.4px] text-[14px] leading-[16.8px] font-normal text-[#6f6f6f] overflow-hidden text-ellipsis cursor-pointer group"} style={{transition: ".3s ease-in-out", height: shrotenedDesc.length > 150 ? descOpen ? theDescRef.current?.scrollHeight : "65px" : theDescRef.current?.scrollHeight, position: "relative"}}>
                            <p className={""} onClick={toggleDescOpen} ref={theDescRef}>{shrotenedDesc}</p>
                            <div className="pointer-events-none absolute top-0 left-0 right-0 bottom-0 z-4" style={{backgroundImage: "linear-gradient(to top, #f4f4f5ff, #f4f4f500 40%)", opacity: descOpen ? "0" : "1", transition: ".3s", display: shrotenedDesc.length > 150 ? "block" : "none" }}></div>
                            <div className="cursor-pointer absolute bottom-0 left-[50%] px-4 py-2 bg-white opacity-0 group-hover:opacity-100 transition-all duration-300 rounded-xl" style={{transform: "translateX(-50%)", display: shrotenedDesc.length > 150 ? "block" : "none"}} onClick={toggleDescOpen}>{descOpen ? "Voir moins" : "Voir plus"}</div>

                            {/* <p className={descOpen ? "md:text-[16px] md:leading-[22.4px] text-[14px] leading-[16.8px] font-normal text-[#6f6f6f] overflow-hidden text-ellipsis" : "md:text-[16px] md:leading-[22.4px] text-[14px] leading-[16.8px] font-normal text-[#6f6f6f] overflow-hidden text-ellipsis cursor-pointer" } onClick={toggleDescOpen} ref={theDescRef}>{user.description}</p> */}
                        </div>
                        {/* <div className={descOpen ? "md:text-[16px] md:leading-[22.4px] text-[14px] leading-[16.8px] font-normal text-[#6f6f6f] overflow-hidden text-ellipsis" : "md:text-[16px] md:leading-[22.4px] text-[14px] leading-[16.8px] font-normal text-[#6f6f6f] overflow-hidden text-ellipsis cursor-pointer"}>
                            <p className={descOpen ? "md:text-[16px] md:leading-[22.4px] text-[14px] leading-[16.8px] font-normal text-[#6f6f6f] overflow-hidden text-ellipsis" : "md:text-[16px] md:leading-[22.4px] text-[14px] leading-[16.8px] font-normal text-[#6f6f6f] overflow-hidden text-ellipsis cursor-pointer" } onClick={toggleDescOpen} style={{transition: ".3s ease-in-out", height: user.description.length > 150 ? descOpen ? "auto" : "65px" : "auto"}}>{user.description}</p>
                        </div> */}
                    </div>
                    <div className="lg:hidden">
                        <p className={"md:text-[16px] md:leading-[22.4px] text-[14px] leading-[16.8px] font-normal text-[#6f6f6f] overflow-hidden text-ellipsis"} >{shrotenedDesc}</p>
                    </div>

                </div>
                <div className="flex flex-row gap-[45px]">
                    <StatFlex title="Âge" value={user.age}/>
                    <StatFlex title="Pays" value={user.country}/>
                    <StatFlex title="Langues" value={user.languages?.join(", ")}/>
                </div>
                <div className="w-full mt-auto">
                    {loggedIn ?
                        // !isRequestSent ?<RoundGreyPlain className="py-[13.5px] w-full font-semibold lg:text-[18px] lg:leading-[23.44px] text-[16px] leading-[20.83px] flex justify-center" text={"Réserver " + toTitleCase(user.name?.split(" ")[0]) + " pour une prestation"} isButton={true} onClick={sendRequest}/>
                        !requestSent ?<RoundGreyPlain className="py-[13.5px] w-full font-semibold lg:text-[18px] lg:leading-[23.44px] text-[16px] leading-[20.83px] flex justify-center" text={"Réserver " + toTitleCase(user.name?.split(" ")[0]) + " pour une prestation"} isButton={true} onClick={setModalShown}/>
                        :
                        requestPending ?
                            <BigLoadingButton active={false} onClick={()=>{}} text='Requête en cours'/>
                            :
                            <BigWhiteButton active={false} onClick={()=>{}} text="Requête envoyée"/>
                    :
                    <RoundGreyPlain className="py-[13.5px] w-full font-semibold lg:text-[18px] lg:leading-[23.44px] text-[16px] leading-[20.83px] flex justify-center" text={"Réserver " + toTitleCase(user.name?.split(" ")[0]) + " pour une prestation"} isButton={true} onClick={bookForLater}/>
                    }
                </div>
            </div>
        </div>}
    </>;
};

const doNothing= (e: any) => {//This is necessary to prevent the modal from disapearing when its body is clicked
    e.preventDefault();
    e.stopPropagation();
};

const ModalForPrice= ({data, hideModal, setRequestSent}: {data: {name: string, salary: number, id: number, favorite_domain: string}, hideModal: ()=> void, setRequestSent: ()=> void}) => {

    const [formStates, setFormStates]= useState<{objet: string, desc: string}>({objet: '', desc: ''});
    const handleChange= (event: any) => {
        setFormStates({...formStates, [event.currentTarget.name]: event.currentTarget.value});
    };

    const handleWYS= (content: any) => {
        setFormStates({...formStates, ['desc'] : content});
    };

    const [errorSending, setErrorSending]= useState<boolean>(false);

    const [requestPending, setRequestPending]= useState<boolean>(false);

    const confirmRequest= (e: any) => {
        setRequestPending(true);
        post(
            'api/book-freelance',
            {
                clientID: localStorage.getItem('user_uid'),
                FreelanceID: data.id,
                objet: formStates.objet,
                desc: formStates.desc
            },
            { withCredentials: false }
        ).then(response => {
            if (!(response.status === 200)) {
                throw new Error('HTTP error! Status: ' + response.status);
            } else {
                setRequestSent();
                setRequestPending(false);
                hideModal();
            }
        }).catch(error => {
            console.error('request failed!\n', error);
            setErrorSending(true);
        });
    };

    const formSubmit= (e: any) => {
        e.preventDefault();
        // console.log(formStates);
        confirmRequest(e);
    };

    return <div className="fixed w-full top-0 left-0 right-0 bottom-0 bg-[#1d1d39aa] flex flex-column items-center justify-center z-[30]" onClick={hideModal}>
        <div className="text-[12px] leading-[14.4px] text-white md:text-[16px] md:leading-[20.83px] text-white w-[320px] md:w-[500px] bg-primary-blue rounded-[20px] flex flex-col gap-[10px] px-[30px] py-[24px]" onClick={doNothing}>
            {errorSending ?
                <>
                    <img src={InfoW} alt="INFO" width={"20"} height={"20"} className="w-[20px] h-[20px]" />
                    <p className="font-normal">
                        Une erreur s'est produite, nous nous excusons du désagrément encouru. Veuilez réessayer plus tard.
                    </p>
                    <div className="flex flex-row gap-[5px]">
                        <button className="md:px-[27px] md:py-[13.5px] px-[10px] py-[5px] text-[12px] text-white md:text-[16px] md:leading-[20.83px] leading-[15.62px] font-semibold text-white bg-[#ffffff22] rounded-full hover:bg-[#ffffff55]" onClick={hideModal}>Retourner sur la page</button>
                    </div>
                </>
                :
                <>
                    <img src={InfoW} alt="INFO" width={"20"} height={"20"} className="w-[20px] h-[20px]" />
                    <p className="font-semibold text-[18px]">
                        Vous allez reserver {data.name} pour une prestation comme {data.favorite_domain}.<br />
                        {/* Ses honoraires sont de {data.salary}€ par mois.<br /> */}
                        <span className='font-normal text-[16px] text-[#fffa]'>Veuillez entrer les détails de votre réservation et cliquez sur réserver pour confirmer.</span>
                    </p>
                    <form action="" onSubmit={formSubmit} className=''>
                        <div className="w-full flex flex-col gap-4 pb-4 mt-4">
                            <div className="flex flex-col gap-2">
                                <label htmlFor="objet">Objet/intitulé de la mission</label>
                                <input type="text" id='objet' name='objet' value={formStates['objet']} onChange={handleChange} className='p-2 text-[#1d1d39] rounded-[5px]' />
                            </div>
                            <div className="flex flex-col gap-2 WOS-quill">
                                <label htmlFor="desc">Description de la mission</label>
                                {/* <textarea id='desc' name='desc' value={formStates['desc']} onChange={handleChange} className='p-2 text-[#1d1d39] rounded-[5px]' rows={4}/> */}
                                <WYSIWYGEditor onChange={handleWYS} value={formStates['desc']} />
                            </div>
                            <input type='submit' className='hidden' />
                        </div>
                        <div className="flex flex-row gap-[5px]">
                            {
                                requestPending ?
                                    <SmallLoadingButton active={false} text='Réserver' cString='bg-[#ffffff22] rounded-full text-white l22' bigText={true} />
                                    :
                                    <RoundBluePlain isButton={true} className="md:px-[27px] md:py-[13.5px] px-[10px] py-[5px] text-[12px] text-white md:text-[16px] md:leading-[20.83px] leading-[14.4px] text-white md:text-[16px] md:leading-[20.83px] font-semibold" text="Réserver" onClick={formSubmit} />
                            }
                            <button className="md:px-[27px] md:py-[13.5px] px-[10px] py-[5px] text-[12px] text-white md:text-[16px] md:leading-[20.83px] leading-[15.62px] font-semibold text-white bg-[#ffffff22] rounded-full hover:bg-[#ffffff55]" onClick={hideModal}>Annuler</button>
                        </div>
                    </form>
                </>
            }
        </div>
    </div>;
};

const UserCardLoading= ()=> {
    return<>
        <div className="lg:w-full w-[95vw] lg:max-w-[989px] max-w-[450px] lg:mt-[113px] mt-[80px] mx-auto rounded-[10px] overflow-hidden grid lg:grid-cols-[400px_auto] lg:grid-rows-[100%] grid-rows-[340px_auto] bg-[#f4f4f5]">
            <div className="w-full h-full overflow-hidden bg-cover bg-center relative gradient-animated"></div>
            <div className="flex flex-col items-stretch gap-[25px] lg:px-[37px] lg:py-[33px] px-[30px] py-[30px]">
                <div className="flex flex-col gap-[12px]">
                    <div className="flex flex-row gap-[8px] items-center">
                        <div className="w-full h-[2em] gradient-animated"></div>
                        <div className="flex flex-row user-stars items-center w-full h-[2em] gradient-animated">
                        </div>
                        <div className="w-full h-[2em] gradient-animated"></div>
                    </div>
                    <div className="h-[2em] w-[50%] gradient-animated"></div>
                </div>
                <div className="flex flex-col gap-[15px]">
                    <div className="w-full h-[2em] gradient-animated"></div>
                    <div className="lg:max-h-[65px] lg:max-h-[60px] h-[65px] w-full gradient-animated"></div>
                </div>
                <div className="flex flex-row gap-[45px]">
                    <div className="gradient-animated h-[2em] w-full"></div>
                    <div className="gradient-animated h-[2em] w-full"></div>
                    <div className="gradient-animated h-[2em] w-full"></div>
                </div>
                <div className="h-[4em] w-full gradient-animated"></div>
            </div>
        </div>
    </>;
};

const StatFlex= ({title, value}: any) => {
    return<div className="flex flex-col gap-[14px]">
        <div className="md:text-[20px] md:leading-[24px] text-[18px] leading-[21.6px] font-normal">{title}</div>
        <div className="text-[#6f6f6f] md:text-[16px] md:leading-[22.4px] text-[14px] leading-[19.6px] font-normal">{value}</div>
    </div>;
};

const DomainFlex= ({domain, index, skills, keyIndex}: any)=> {

    const listOfSkills= skills.filter((singleSkill: any)=>singleSkill.domaine===domain);

    return <div className="lg:max-w-[989px] max-w-[340px] lg:w-full w-[95vw] flex flex-col lg:gap-[20px] gap-[16px] mx-auto" key={"domain-" + index + keyIndex}>
        <div className="rounded-[10px] bg-primary-blue text-white font-medium lg:text-[25px] lg:leading-[30px] text-[20px] leading-[24px] lg:py-[15px] lg:px-[30px] py-[10px] px-[20px] w-max max-w-[90vw]">{domain}</div>
        <div className="flex flex-row flex-wrap gap-[9px]">
            {listOfSkills?.map((skill: any, idx: number) => (
                <div className="rounded-[10px] lg:w-[490px] w-[340px] bg-[#f4f4f5] lg:px-[29px] lg:py-[30px] px-[28px] py-[20px]" key={"domain-" + domain + index + "-" + idx}>
                    <div className="flex flex-row justify-between">
                        <div className="lg:text-[20px] lg:leading-[24px] text-[18px] leading-[21.6px] font-medium text-primary-blue">{skill.competence}</div>
                        <div className="flex flex-row items-center gap-[5px] w-max shrink-0">
                            <div className="text-[14px] leading-[19.6px] font-normal font-dm-sans">Expérience</div>
                            <div className="text-[#895ef6] text-[14px] leading-[19.6px] rounded-[5px] bg-[#895ef620] p-[5px] shrink-0">{skill.experience}</div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </div>;
};

const Domains= ({user}: any)=> {
    return<>
        <div className="w-full flex flex-col lg:gap-[96px] gap-[60px] py-[87px]">
            {user?.domains?.map((domain: any, index: number)=>(
                <DomainFlex domain={domain} index={index} skills={user?.competences} keyIndex={"Domain-" + index} key={"main-" + "Domain-" + index}/>
            ))}
        </div>
    </>;
};

const MoreFreelances= ()=> {
    
    const [freels, setFreels]= useState([]);
    const [freelsLoading, setFreelsLoading]= useState(true);


    useEffect(()=>{
        /*Fetching a few freelances*/
        (async function() {

            let response= await _getFreelances("?page_size=40");
            setFreels(response.data);
        })();
        /*Fetching a few freelances END*/
    },[]);

    useEffect(()=>{
        if (freels.length > 0){
            setFreelsLoading(false);
        } else {
            setFreelsLoading(true);
        }
    }, [freels]);

    return<>
        <div className="w-full py-[110px] bg-[#f4f4f5] flex flex-col gap-[47px]">
            <h2 className="lg:max-w-[989px] max-w-[95vw] mx-auto lg:text-[40px] lg:leading-[48px] text-[30px] leading-[36px] font-semibold text-primary-blue w-full xl:text-left text-center">Ces profils peuvent aussi vous intéresser</h2>
            <MoreFreelancesSlider freels={freels} freelsLoading={freelsLoading}/>
        </div>
    </>;
};

const MoreFreelancesSlider= ({freels, freelsLoading}: any) => {
    return<>
        <ExtraLargeScreenSlider freels={freels} freelsLoading={freelsLoading}/>
        <LargeScreenSlider freels={freels} freelsLoading={freelsLoading} />
        <div className="w-full overflow-hidden">
            <SmallScreenSlider freels={freels} freelsLoading={freelsLoading} />
        </div>
    </>;
};

const SmallScreenSlider= ({freels, freelsLoading}: any) => {//<-for screens below 1024px
    const spaceBetweenSlides= 15;
    const slideSizesInX= 324;
    const w= useWindowSize();
    const [carouselContainerSize, setCarouselContainerSize]= useState(0);
    
    const carouselContainerRef= useRef<HTMLDivElement>(null);
    
    const [slidesToShow, setSlidesToShow]= useState((carouselContainerSize + spaceBetweenSlides) / (slideSizesInX + spaceBetweenSlides));

    useEffect(()=>{
        const windowResizeHandler= () =>{
            if(carouselContainerRef.current){
                setCarouselContainerSize(carouselContainerRef.current.offsetWidth);
            }
        };
        window.addEventListener("resize", windowResizeHandler);
        window.dispatchEvent(new Event("resize"));//<- This has to be here otherwise the logic breaks because slidesToShow is calculated when carouselContainerSize is 0 and is never updated afterwards. So manually firing the resize event forces a recalculation with the correct values.
        return ()=> {
            window.removeEventListener("resize", windowResizeHandler);
        };
    },[]);

    useEffect(()=> {
        if(carouselContainerRef.current!== null){
            setSlidesToShow((carouselContainerSize + spaceBetweenSlides) / (slideSizesInX + spaceBetweenSlides));
        } else {
            setSlidesToShow((w + spaceBetweenSlides) / (slideSizesInX + spaceBetweenSlides));
        }
    },[carouselContainerSize, w]);

    return<div className="w-[95%] mx-auto no-clip-slider lg:hidden" ref={carouselContainerRef}>
        <CarouselProvider  visibleSlides={slidesToShow} totalSlides={freels.length} naturalSlideHeight={470} naturalSlideWidth={285} isIntrinsicHeight={true} step={1} >
            <Slider>
                <InnerSliderForAllThree freelsLoading={freelsLoading} freels={freels} />
            </Slider>
        </CarouselProvider>
    </div>;
};

const LargeScreenSlider= ({freels, freelsLoading}: any) => {//<-for screens between 1024 and 1280px

    const [currentSlide, setCurrentSlide]= useState(0);

    const [canNext, setCanNext]= useState(false);
    const [canPrev, setCanPrev]= useState(false);

    useEffect(()=>{
        if (currentSlide <= 0){
            setCurrentSlide(0);
            setCanPrev(false);
        } else {
            setCanPrev(true);
        }
        if (currentSlide >= freels.length - 2){
            setCurrentSlide(freels.length - 2);
            setCanNext(false);
        } else {
            setCanNext(true);
        }
    }, [currentSlide]);
    
    const nextSlide= () => {
        if (currentSlide=== freels.length - 2){
            return;
        } else {
            setCurrentSlide(v=>v+1);
        }
    };
    const prevSlide= () => {
        if (currentSlide=== 0){
            return;
        } else {
            setCurrentSlide(v=>v-1);
        }
    };

    return<div className="max-w-[660px] mx-auto xl:hidden lg:block hidden relative">
        <CarouselProvider  visibleSlides={2} totalSlides={freels.length} naturalSlideHeight={470} naturalSlideWidth={285} isIntrinsicHeight={true} step={1} currentSlide={currentSlide} >
            <Slider>
                <InnerSliderForAllThree freelsLoading={freelsLoading} freels={freels} />
            </Slider>
        </CarouselProvider>
        {
            canPrev &&
            <button onClick={prevSlide} className="w-[48px] h-[48px] flex items-center justify-center border-[1px] border-primary-blue rounded-[50%] absolute top-[50%] left-[-40px] transform translate-x-[-100%] translate-y-[-50%]"><img src={right} alt="arrow-right" style={{transform: "rotate(180deg)"}} /></button>
        }
        {
            canNext &&
            <button onClick={nextSlide} className="w-[48px] h-[48px] flex items-center justify-center border-[1px] border-primary-blue rounded-[50%] absolute top-[50%] right-[-40px] transform translate-x-[100%] translate-y-[-50%]"><img src={right} alt="arrow-left" /></button>
        }
    </div>;
};

const ExtraLargeScreenSlider= ({freels, freelsLoading}: any) => {//<-for screens above 1280px

    const [currentSlide, setCurrentSlide]= useState(0);

    const [canNext, setCanNext]= useState(false);
    const [canPrev, setCanPrev]= useState(false);

    useEffect(()=>{
        if (currentSlide <= 0){
            setCurrentSlide(0);
            setCanPrev(false);
        } else {
            setCanPrev(true);
        }
        if (currentSlide >= freels.length - 3){
            setCurrentSlide(freels.length - 3);
            setCanNext(false);
        } else {
            setCanNext(true);
        }
    }, [currentSlide, freels]);

    const nextSlide= () => {
        if (currentSlide=== freels.length - 3){
            return;
        } else {
            setCurrentSlide(v=>v+1);
        }
    };
    const prevSlide= () => {
        if (currentSlide=== 0){
            return;
        } else {
            setCurrentSlide(v=>v-1);
        }
    };

    return<div className="max-w-[989px] mx-auto xl:block hidden relative">
        <CarouselProvider  visibleSlides={3} totalSlides={freels.length} naturalSlideHeight={470} naturalSlideWidth={285} isIntrinsicHeight={true} step={1} currentSlide={currentSlide} >
            <Slider>
                <InnerSliderForAllThree freelsLoading={freelsLoading} freels={freels} />
            </Slider>
        </CarouselProvider>
        {
            (canPrev ) &&
            <button onClick={prevSlide} className="w-[48px] h-[48px] flex items-center justify-center border-[1px] border-primary-blue rounded-[50%] absolute top-[50%] left-[-40px] transform translate-x-[-100%] translate-y-[-50%]"><img src={right} alt="arrow-right" style={{transform: "rotate(180deg)"}} /></button>
        }
        {
            (canNext) &&
            <button onClick={nextSlide} className="w-[48px] h-[48px] flex items-center justify-center border-[1px] border-primary-blue rounded-[50%] absolute top-[50%] right-[-40px] transform translate-x-[100%] translate-y-[-50%]"><img src={right} alt="arrow-left" /></button>
        }
    </div>;
};

const InnerSliderForAllThree= ({freelsLoading, freels}: {freelsLoading: boolean, freels: any}) => {
    return <>
        {
            freelsLoading ?
            [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((el: any, index: number) => (
                <Slide key={"placeholder-" + index} index={index}>
                    <FreelanceCardLoading isWhite={false} key={"placeholder-" + index} />
                </Slide>
            ))
            :
            freels.map((el: any, index: number) => (
                <Slide key={"freelance-slide-" + index} index={index}>
                    <FreelanceCard rating={el?.avg_rating} firstname={el?.name?.split(' ')[0]} lastname={el?.name?.split(' ')?.slice(1)?.join(' ')} photo={el.image_url.image_url_512 ?? el.image_url.image_url_128} audioAvailable={el.audio} salary={el.price_per_month} ratersNumber={el.rate_number} skills={el.competences.map((comp: any) => comp.name)} online={!el.booked} xp={el?.experience} jobTitle={el?.favorite_domain && el.favorite_domain[0].name} id={el.id} isWhite={true}/>
                </Slide>
            ))
        }
    </>;
};